import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const FinancialPeriodInput = () => {
  const { financialPeriodId = '' } = useParams();
  const decodedId = financialPeriodId ? atob(financialPeriodId) : financialPeriodId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [financialPeriods, setFinancialPeriods] = useState([]);
  const route = 'financial_period';

  useEffect(() => {
    if (financialPeriodId) {
      setIsEditing(true);
      fetchFinancialPeriodDetails();
    }
    fetchFinancialPeriods();
  }, [financialPeriodId]);

  const fetchFinancialPeriodDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.financial_period}${id}/`, { headers });
      const financialPeriodDetails = response.data;

      setFormData(financialPeriodDetails);
    } catch (error) {
      console.error('Error fetching financial period details:', error);
    }
  };

  const fetchFinancialPeriods = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.financial_period}`, { headers });
      const financialPeriods = response.data;

      const financialPeriodOptions = financialPeriods.map(financialPeriod => ({
        value: financialPeriod.id,
        label: financialPeriod.name,
      }));

      setFinancialPeriods(financialPeriodOptions);
    } catch (error) {
      console.error('Error fetching financial periods:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    // Handle form submission success
  };

  const financialPeriodFields = [
    {
      name: 'start_date',
      label: 'Start Date',
      type: 'date',
    },
    {
      name: 'end_date',
      label: 'End Date',
      type: 'date',
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'OPEN', label: 'Open' },
        { value: 'CLOSED', label: 'Closed' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Financial Period' : 'Create Financial Period'}</h1>
      <FormComponent
        fields={financialPeriodFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default FinancialPeriodInput;